import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { FileCategory } from '~/client/graph'
import * as Icons from '~/client/src/shared/components/Icons'

interface FileCategoryIconProps {
  fileCategory: string
  className?: string
}

const FileCategoryIcon: React.FC<FileCategoryIconProps> = ({
  fileCategory,
  className: customClassName,
}) => {
  let IconComponent: (props: any) => JSX.Element = () => null

  switch (fileCategory) {
    case FileCategory.Image:
      IconComponent = Icons.FileImage
      break
    case FileCategory.Video:
      IconComponent = Icons.FileVideo
      break
    case FileCategory.Document:
      IconComponent = Icons.FileWord
      break
    case FileCategory.Spreadsheet:
      IconComponent = Icons.FileExcel
      break
    case FileCategory.Presentation:
      IconComponent = Icons.FilePowerpoint
      break
    default:
      IconComponent = Icons.FileImage
  }

  return (
    <IconComponent
      className={classList({
        'text-grey-light no-grow': true,
        [customClassName]: true,
      })}
    />
  )
}

export default FileCategoryIcon
